export default {
  SET_TOKEN: '@WS/AUTH/SET_TOKEN',
};
